import { useCategoryLibbyCall } from "./CategoryBusinessGenerated";
import { Publication } from "../../models";

export const useCategoryById = (id: string) => useCategoryLibbyCall<Publication[]>({ methodName: "getCategoryPublications", params: [id] });
